export const UPDATE_LAYER_VISIBILITY = 'UPDATELAYERVISIBILITY'
export const FETCH_CONFIG = 'FETCHCONFIG'
export const FETCH_INFO = 'FETCHINFO'
export const FETCH_GEMEENTEN = 'FETCHGEMEENTEN'
export const CLEAR_SEARCHPARAM = 'CLEAR_SEARCHPARAM'

const ALL_ACTIONS = {
    UPDATE_LAYER_VISIBILITY,
    FETCH_CONFIG,
    FETCH_INFO,
    FETCH_GEMEENTEN,
    CLEAR_SEARCHPARAM
}

export default ALL_ACTIONS